<template>
    <v-col cols="12" :style="displayWithColumns">
        <v-col :cols="numberColunmsFilter" style="padding: 0px; padding-top: 20px; padding-left: 12px; padding-right: 12px;">
            <AppMainFiltersSearchCard tituloTela="filtros">
                <v-layout row wrap justify-start pa-3>
                    <v-flex sm12 xs12 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" v-model="filtroLoteProducao.nmProdutorSearch" label="Produtor" 
                            hide-details outlined ></v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" v-model="filtroLoteProducao.nrPavilhaoSearch" label="Pavilhão" 
                            hide-details outlined ></v-text-field>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                        <v-autocomplete v-on:keyup.enter="searchLotes(false)" v-model="filtroLoteProducao.csTipoLoteSearch" :items="tipoLoteSearch" style="height:50px;"
                            color="primary" item-text="dsTipoLote" item-value="csTipoLote" label="Fase"
                            no-data-text="Nenhum registro" outlined>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" v-model="filtroLoteProducao.nrControleSearch" label="Controle" 
                            hide-details outlined ></v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12 pa-1>
                        <span>Alojamento</span>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1 style="height: 65px;">
                        <SelectDate v-on:keyup.enter="searchLotes(false)" label="De" :clearable="false" v-model="filtroLoteProducao.dtInicioAlojamentoSearch"></SelectDate>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1 style="height: 65px;">
                        <SelectDate v-on:keyup.enter="searchLotes(false)" label="Até" :clearable="false" v-model="filtroLoteProducao.dtFimAlojamentoSearch"></SelectDate>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                        <v-autocomplete v-on:keyup.enter="searchLotes(false)" v-model="filtroLoteProducao.csStatusLoteSearch" :items="statusLoteSearch" style="height:50px;"
                            color="primary" item-text="dsStatusLote" item-value="csStatusLote" label="Status"
                            no-data-text="Nenhum registro" outlined>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex lg6 md6 sm6 xs6 pa-1>
                        <v-autocomplete v-on:keyup.enter="searchLotes(false)" v-model="filtroLoteProducao.csGeneroLoteSearch" :items="generoLoteSearch" style="height:50px;"
                            color="primary" item-text="dsGeneroLote" item-value="csGeneroLote" label="Gênero"
                            no-data-text="Nenhum registro" outlined>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12 pa-1 pt-3>
                        <span>Mortalidade</span>
                    </v-flex>
                    <v-flex lg6 md4 sm4 xs4 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" label="De" type="number" outlined v-model.number="filtroLoteProducao.nrMortalidadeMinSearch" 
                            style="height:50px;" suffix="%">
                        </v-text-field>
                    </v-flex>
                    <v-flex lg6 md4 sm4 xs4 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" label="Até" type="number" outlined v-model.number="filtroLoteProducao.nrMortalidadeMaxSearch" 
                            style="height:50px;" suffix="%">
                        </v-text-field>
                    </v-flex>
                    <v-flex lg12 md12 sm12 xs12 pa-1 pt-3>
                        <span>Desvio de Consumo</span>
                    </v-flex>
                    <v-flex lg6 md4 sm4 xs4 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" label="De" type="number" outlined v-model.number="filtroLoteProducao.nrConsumoMinSearch"
                            style="height:50px;" suffix="%">
                        </v-text-field>
                    </v-flex>
                    <v-flex lg6 md4 sm4 xs4 pa-1>
                        <v-text-field v-on:keyup.enter="searchLotes(false)" label="Até" type="number" outlined v-model.number="filtroLoteProducao.nrConsumoMaxSearch" 
                            style="height:50px;" suffix="%">
                        </v-text-field>
                    </v-flex>                    
                    <v-flex lg12 md12 sm12 xs12 pa-1 pt-3>
                        <v-select v-on:keyup.enter="searchLotes(false)" outlined :items="extensionistas" v-model="filtroLoteProducao.cdResponsavelTecnicoSearch" style="height:50px;" 
                            itemValue="idResponsavelTecnico" 
                            itemText="displayName" label="Extensionista"/>
                    </v-flex>
                    <v-flex lg11 md11 sm11 xs12 pa-4 mb-1>
                        <v-layout row wrap justify-center>
                            <v-flex lg6 ma-0 pa-0>
                                <v-btn id="clear" rounded style="background-color:#e8e8e8;" @click="clearFilters">
                                    <span class="marginSpan"> Limpar </span>
                                    <v-icon small>fas fa-eraser</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex lg6 ma-0 pa-0>
                                <v-btn id="search" dark rounded color="primary" @click="searchLotes(true)">
                                    <span class="marginSpan"> Pesquisar </span>
                                    <v-icon small>fas fa-search</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </AppMainFiltersSearchCard>
        </v-col>
        <v-col :cols="numberColunmsList" style="margin-top: -40px; padding: 0px; padding-top: 20px;">
            <AppMainSearchCard :tituloTela="tituloTela" :canDelete="false" :canSearch="false" :isSearch="true"
                @add="$router.push({ path: '/loteProducaoForm' })">
                <v-layout row wrap justify-center pa-3>
                    <v-flex sm11 xs11 md12 lg12>
                        <v-data-table :headers="headers" @click:row="editItem" no-results-text="Nenhum registro encontrado" hide-default-footer
                            :items="lotes" color="secondary" :loading="isLoadinglotesProducao"
                            :server-items-length="filtroLoteProducao.totalLotes" :options.sync="options"
                            loading-text="Carregando Lotes....aguarde">
                            <template v-slot:item.nrDesvioConsumo="{ item }">
                                <v-chip :color="getColorConsumo(item.nrDesvioConsumo)" dark>{{ item.nrDesvioConsumo + '%' }}</v-chip>
                            </template>
                            <template v-slot:item.nrIndiceBaixas="{ item }">
                                <v-chip :color="getColorMortalidade(item.marcadorMortalidade)" dark>{{ item.nrIndiceBaixas + '%' }}</v-chip>
                            </template>
                            <template v-slot:item.dtAlojamento="{ item }">
                                {{ item.dtAlojamento | dateIsoToLocale }}
                            </template>
                            <template v-slot:item.sgSexo="{ item }">
                                {{ item.sgSexo | expadeGenero }}
                            </template>
                        </v-data-table>
                        <v-divider/>
                        <v-layout row wrap justify-center >
                            <v-flex sm10 xs10 md10 lg10 pa-1 pt-2>
                                <v-pagination v-model="filtroLoteProducao.page" :length="pageCount" @click.native="searchLotes(false)"></v-pagination>
                            </v-flex>
                            <v-flex sm1 xs1 md1 lg1 pa-1 pl-10 pt-5>
                                <span>Total: {{filtroLoteProducao.totalLotes}}</span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </AppMainSearchCard>
        </v-col>
    </v-col>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'
import { daysBetweenDates, dateIsoToLocal, dateLocalToIso } from '@/filters/utils.js'
import { data1InferiroData2, campoMaiorOuIgualZero } from '@/filters/rules'
import SelectDate from '@/components/general/SelectDate.vue'
import AppMainFiltersSearchCard from '@/components/layout/AppMainFiltersSearchCard.vue'
import { mask } from 'vue-the-mask'

export default {
    components: {
        AppMainSearchCard,
        SelectDate,
        AppMainFiltersSearchCard,
    },
    directives: {
        mask,
    },
    data: () => ({
        itemsPerPage: 12,
        tituloTela: 'Lotes de Produção',
        registroSelected: '',
        headers: [            
            { text: 'Produtor', value: 'jsonProdutor.nmProdutor', align: 'start', sortable: false},
            { text: 'Pavilhão', value: 'nrPavilhao', align: 'start', sortable: false},
            { text: 'Alojamento', value: 'dtAlojamento', align: 'start', sortable: false},
            { text: 'Dias alojados', value: 'nrDiasAlojados', align: 'start', sortable: false },
            { text: 'Saldo', value: 'qtSaldoAnimais', align: 'start' },
            { text: 'Status', value: 'dsStatus', align: 'start', sortable: false},
            { text: 'Gênero', value: 'sgSexo', align: 'start', sortable: false},
            { text: 'Consumo', value: 'nrDesvioConsumo', align: 'start', sortable: false},
            { text: 'Mortalidade', value: 'nrIndiceBaixas', align: 'start', sortable: false},
            { text: 'Fase', value: 'jsonUnidadeExploracao.csTipoUnidadeExploracao', align: 'start', sortable: false},
            { text: 'Controle', value: 'nrLoteControle', align: 'start', sortable: false},
            { text: 'Extensionista', value: 'responsavelTecnico.nmPessoa', align: 'start', sortable: false},
        ],
        lotesProducao: [],
        isLoadinglotesProducao: false,
        isErrorLoteProducao: false,
        query: {},
        statusLoteSearch: [
            {
                csStatusLote: 'AB',
                dsStatusLote: 'Aberto'
            },
            {
                csStatusLote: 'FE',
                dsStatusLote: 'Fechado'
            },
            {
                csStatusLote: null,
                dsStatusLote: 'Todos'
            }
        ],
        tipoLoteSearch: [
            {
                csTipoLote: 'CR',
                dsTipoLote: 'Creche'
            },
            {
                csTipoLote: 'TR',
                dsTipoLote: 'Terminação'
            },
            {
                csTipoLote: 'WF',
                dsTipoLote: 'Wean to Finish'
            }
            // {
            //     csTipoLote: 'UP',
            //     dsTipoLote: 'UPL'
            // }
        ],
        generoLoteSearch: [
            {
                csGeneroLote: 'MA',
                dsGeneroLote: 'Macho'
            },
            {
                csGeneroLote: 'FE',
                dsGeneroLote: 'Fêmea'
            },
            {
                csGeneroLote: 'MI',
                dsGeneroLote: 'Misto'
            }
        ],
        filtersObject: [
            {
                value: 'nmProdutorSearch',
                type: 'text',
                operator: 'ilike',
                field: 'jsonProdutor',
                subfield: 'nmProdutor'
            },
            {
                value: 'nrPavilhaoSearch',
                type: 'text',
                operator: 'equals',
                field: 'nrPavilhao',
                subfield: ''
            },
            {
                value: 'dtInicioAlojamentoSearch',
                type: 'date',
                operator: '>=',
                field: 'dtAlojamento',
                subfield: ''
            },
            {
                value: 'dtFimAlojamentoSearch',
                type: 'date',
                operator: '<=',
                field: 'dtAlojamento',
                subfield: ''
            }
        ],
        displayWithColumns: {
            display: 'flex'
        },
        numberColunmsFilter: 2,
        numberColunmsList: 10,
        options: {},
        maskNumbers: '#########',
    }),
    filters: {
        expadeGenero(genero) {
            if (genero.toUpperCase() == 'MA') return 'Macho'
            if (genero.toUpperCase() == 'FE') return 'Fêmea'
            return 'Misto'
        }
    },
    computed: {
        filtroLoteProducao: {
			get() {
				return this.$store.state.filtroLoteProducao
			},
			set(value) {
				this.$store.commit("mtChangeFiltroLoteProducao", value)
			}
		},
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        tabelasMetaMortalidade() {
            return this.$store.state.tabelasMetaMortalidade
        },
        qtDesvioMedioConsumo() {
            return this.$store.getters.getValorTabela('qtDesvioMedioConsumoPercentual')[0] != undefined ? 
                this.$store.getters.getValorTabela('qtDesvioMedioConsumoPercentual')[0].stValor : 2.5
        },
        qtDesvioMaximoConsumo() {
            return this.$store.getters.getValorTabela('qtDesvioMaximoConsumoPercentual')[0] != undefined ?
                this.$store.getters.getValorTabela('qtDesvioMaximoConsumoPercentual')[0].stValor : 5
        },
        lotes() {
            var context = this
            if (this.$store.state.lotesProducao != null)
            {
                let data = this.$store.state.lotesProducao.map(entry => {                
                    let dsStatus = !entry.blLoteFechado ? 'Aberto' : 'Fechado'

                    let responsavelTecnico = this.$store.state.extensionistas.find( i => i.idResponsavelTecnico == entry.cdResponsavelTecnico)

                    entry.nrDesvioConsumo = entry.nrDesvioConsumo == null ? '-- ' : entry.nrDesvioConsumo

                    var nrSemana = 0
                    if (entry.nrIndiceBaixas == undefined)
                        return {...entry, marcadorMortalidade: '', responsavelTecnico, dsStatus}

                    var nrDiasAlojados = 0

                    if (entry.dtAlojamento != null)
                    {
                        var totalDiasAlojado = entry.dtAlojamento != null ? context.daysBetweenDates(new Date().toLocaleDateString('pt-br'), 'DD/MM/YYYY', entry.dtAlojamento, 'YYYY-MM-DD') : 0
                        nrDiasAlojados = totalDiasAlojado < 0 ? 0 : totalDiasAlojado
                        nrSemana = nrDiasAlojados / 7
                        nrSemana = Math.ceil(nrSemana) //+ 1
                    }

                    if (entry.blLoteFechado)
                    {
                        nrDiasAlojados = '--' //entry.dtAlojamento != null ? 
                            //context.daysBetweenDates(entry.dtFechamentoLote, "YYYY-MM-DD", entry.dtAlojamento, "YYYY-MM-DD") : 0
                    }

                    if (context.tabelasMetaMortalidade == undefined)
                        return {...entry, marcadorMortalidade: '', responsavelTecnico, dsStatus}

                    var tabela = context.tabelasMetaMortalidade.find(i => i.sgTipoUep == entry.jsonUnidadeExploracao.csTipoUnidadeExploracao)

                    if (tabela == undefined || tabela.pontos == undefined)
                        return {...entry, marcadorMortalidade: '', responsavelTecnico, dsStatus}

                    let marcadorMortalidade = tabela.pontos.find(t => t.nrDia == nrSemana)
                    if (marcadorMortalidade == undefined)
                    {
                        marcadorMortalidade = tabela.pontos[tabela.pontos.length -1]
                    }
                    
                    marcadorMortalidade = marcadorMortalidade != undefined ? Math.abs(entry.nrIndiceBaixas) >= marcadorMortalidade.mortalidade ? 'alto' : '' : ''
                    
                    return {...entry, marcadorMortalidade, responsavelTecnico, dsStatus, nrDiasAlojados}
                })
                
                // if (this.$store.state.lotesProducao.length == 10)
                // {
                //     this.$store.dispatch('actLoadAllLotesProducao')
                // }
                this.isLoadinglotesProducao = false
                
                return data
            }
            return []
        },
        extensionistas() {
			return this.$store.state.extensionistas
        },
        pageCount() {
            return this.filtroLoteProducao.totalLotes != 0 ? Math.ceil(this.filtroLoteProducao.totalLotes / this.itemsPerPage) : 0
        },
    },
    methods: {
        daysBetweenDates,
        dateIsoToLocal,
        dateLocalToIso,
        data1InferiroData2,
        campoMaiorOuIgualZero,
        clearFilters() {
            this.filtroLoteProducao = {
                nmProdutorSearch: '',
                nrPavilhaoSearch: '',
                dtInicioAlojamentoSearch: '',
                dtFimAlojamentoSearch: '',
                csStatusLoteSearch: 'AB',
                csGeneroLoteSearch: '',
                csTipoLoteSearch: '',
                nrControleSearch: '',
                cdResponsavelTecnicoSearch: 0,
                nrMortalidadeMinSearch: '',
                nrMortalidadeMaxSearch: '',
                nrConsumoMinSearch: '',
                nrConsumoMaxSearch: '',
                page: 1,
                totalLotes: this.filtroLoteProducao.totalLotes
            }
            this.searchLotes(true)
        },
        searchLotes(limpaPagina) {
            if (this.filtroLoteProducao.dtInicioAlojamentoSearch == "" && this.filtroLoteProducao.dtFimAlojamentoSearch == "" || data1InferiroData2(this.dateLocalToIso(this.filtroLoteProducao.dtInicioAlojamentoSearch), this.dateLocalToIso(this.filtroLoteProducao.dtFimAlojamentoSearch)))
            {
                let query = new URLSearchParams()
                this.isLoadinglotesProducao = true
                this.filtroLoteProducao.totalLotes = 0
                if (limpaPagina)
                {
                    this.filtroLoteProducao.page = 1
                }
                if (this.filtroLoteProducao.nmProdutorSearch != '' && this.filtroLoteProducao.nmProdutorSearch != null)
                {
                    var cfNmProdutor = {"field": "jsonProdutor", "subfield": "nmProdutor", "op": "ilike", "value": '%' + this.filtroLoteProducao.nmProdutorSearch + '%'}
                    query.append("cf", JSON.stringify(cfNmProdutor))
                }
                if (this.filtroLoteProducao.nrPavilhaoSearch != '' && this.filtroLoteProducao.nrPavilhaoSearch != null)
                {
                    query.append("nrPavilhao", this.filtroLoteProducao.nrPavilhaoSearch)
                }
                if(this.filtroLoteProducao.dtInicioAlojamentoSearch != '' && this.filtroLoteProducao.dtInicioAlojamentoSearch != null)
                {
                    var cfDtAlojamentoInicio = {"field": "dtAlojamento", "op": ">=", "value": dateLocalToIso(this.filtroLoteProducao.dtInicioAlojamentoSearch)}
                    query.append("cf", JSON.stringify(cfDtAlojamentoInicio))
                }
                if(this.filtroLoteProducao.dtFimAlojamentoSearch != '' && this.filtroLoteProducao.dtFimAlojamentoSearch != null)
                {
                    var cfDtAlojamentoFim = {"field": "dtAlojamento", "op": "<=", "value": dateLocalToIso(this.filtroLoteProducao.dtFimAlojamentoSearch)}
                    query.append("cf", JSON.stringify(cfDtAlojamentoFim))
                }
                var valueStatusLote = this.filtroLoteProducao.csStatusLoteSearch == 'AB' ? false : this.filtroLoteProducao.csStatusLoteSearch == 'FE' ? true : null
                if (valueStatusLote != null)
                {
                    var cfSgStatusLote = {"field": "blLoteFechado", "op": "==", "value": valueStatusLote}
                    query.append("cf", JSON.stringify(cfSgStatusLote))
                }
                if (this.filtroLoteProducao.csGeneroLoteSearch != '' && this.filtroLoteProducao.csGeneroLoteSearch != undefined)
                {
                    var cfSgSexo = {"field": "sgSexo", "op": "==", "value": this.filtroLoteProducao.csGeneroLoteSearch}
                    query.append("cf", JSON.stringify(cfSgSexo))
                }
                if (!(this.filtroLoteProducao.nrMortalidadeMinSearch === '') && this.filtroLoteProducao.nrMortalidadeMinSearch != null)
                {
                    var cfMortalidadeMin = {"field": "nrIndiceBaixas", "op": ">=", "value": this.filtroLoteProducao.nrMortalidadeMinSearch}
                    query.append("cf", JSON.stringify(cfMortalidadeMin))
                }
                if (!(this.filtroLoteProducao.nrMortalidadeMaxSearch === '') && this.filtroLoteProducao.nrMortalidadeMaxSearch != null)
                {
                    var cfMortalidadeMax = {"field": "nrIndiceBaixas", "op": "<=", "value": this.filtroLoteProducao.nrMortalidadeMaxSearch}
                    query.append("cf", JSON.stringify(cfMortalidadeMax))
                }
                if (!(this.filtroLoteProducao.nrConsumoMinSearch === '') && this.filtroLoteProducao.nrConsumoMinSearch != null)
                {
                    var cfConsumoMin = {"field": "nrDesvioConsumo", "op": ">=", "value": this.filtroLoteProducao.nrConsumoMinSearch}
                    query.append("cf", JSON.stringify(cfConsumoMin))
                }
                if (!(this.filtroLoteProducao.nrConsumoMaxSearch === '') && this.filtroLoteProducao.nrConsumoMaxSearch != null)
                {
                    var cfConsumoMax = {"field": "nrDesvioConsumo", "op": "<=", "value": this.filtroLoteProducao.nrConsumoMaxSearch}
                    query.append("cf", JSON.stringify(cfConsumoMax))
                }
                if (this.filtroLoteProducao.csTipoLoteSearch != '' && this.filtroLoteProducao.csTipoLoteSearch != undefined)
                {
                    var cfSgFase = {"field": "jsonUnidadeExploracao", "subfield": "csTipoUnidadeExploracao", "op": "like", "value": this.filtroLoteProducao.csTipoLoteSearch}
                    query.append("cf", JSON.stringify(cfSgFase))
                }
                if (this.filtroLoteProducao.nrControleSearch != '' && this.filtroLoteProducao.nrControleSearch != null)
                {
                    var cfNrLoteControle = {"field": "nrLoteControle", "op": "ilike", "value": this.filtroLoteProducao.nrControleSearch}
                    query.append("cf", JSON.stringify(cfNrLoteControle))
                }
                if (this.filtroLoteProducao.cdResponsavelTecnicoSearch != 0 && this.filtroLoteProducao.cdResponsavelTecnicoSearch != undefined)
                {
                    query.append("cdResponsavelTecnico", this.filtroLoteProducao.cdResponsavelTecnicoSearch)
                }

                let orderLote = {
                    "field": "dtAlojamento",
                    "subfield": null,
                    "desc": true
                }
                query.append("order", JSON.stringify(orderLote))
                
                var paginationString = '?page=' + this.filtroLoteProducao.page + '&per_page=' + this.itemsPerPage

                this.$store.commit('mtChangeLoadingLotesProducao', true)
                this.$axios.get('lote-producao/' + paginationString, { params: query })
                    .then((response) => {
                    if (response.data[0].data != null)
                    {
                        this.filtroLoteProducao.totalLotes = response.data[0].meta['total_itens']
                        this.$store.commit('mtLoadLotesProducao', response.data[0].data)
                    }
                    })
                    .catch( error => {
                        this.$store.commit('setSnack', {type: 'error', msg: error})
                    })
                    .finally( () => {
                        this.isLoadinglotesProducao = false
                        this.$store.commit('mtChangeLoadingLotesProducao', false)
                    })
            }
            else
            {
                this.$store.commit('setSnack', {type: 'error', msg : 'A Data de Início Alojamento deve ser inferior a Data de Fim Alojamento!'})
            }
        },
        verifyTipeOfWindow() {
            if (this.$vuetify.breakpoint.name != 'xs')
            {
                this.numberColunmsFilter = 2
                this.numberColunmsList = 10
                this.displayWithColumns = {
                    display: 'flex'
                }
            }
            else
            {
                this.numberColunmsFilter = 12
                this.numberColunmsList = 12
                this.displayWithColumns = {
                    display: 'unset'
                }
            }
        },
        initViewFromRoute() {
            this.verifyTipeOfWindow()
            this.isLoadinglotesProducao = true
            this.$store.dispatch('actLoadLotesProducao')
            this.$store.dispatch('actLoadEstabelecimentos')
            this.$store.dispatch('actLoadTabelasConsumoRacao')
        },
        editItem (value) {
            this.$router.push({ name: 'loteProducao', params: { id : value.idLoteProducao } })
        },
        getColorConsumo (nrDesvioConsumo) {
            if (Math.abs(nrDesvioConsumo) < this.qtDesvioMedioConsumo) return 'green'
            else if (Math.abs(nrDesvioConsumo) >= this.qtDesvioMaximoConsumo) return 'red'
            else return '#ff8d00'
        },
        getColorMortalidade (marcadorMortalidade) {
            if (marcadorMortalidade == 'medio') return '#ff8d00'
            else if (marcadorMortalidade == 'alto') return 'red'
            else return 'green'
        },
        routeUpdate() {
            this.$router.push({ path : 'loteProducaoSearch', query: this.query })
        },
    },
    mounted () {
        if (this.lotes.length == 0)
        {
            this.verifyTipeOfWindow()
        }
    },
    watch: {
        options: {
            handler () {
                this.searchLotes(true)
            },
            deep: true,
        },
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute()
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
